$.fn.postcodeLookup = function(postCodeId,postCodeName,postCodeSelectId,findAddressBtnId,postcode_api_key) {
    var _this = this;

    // Prevent multiple initializations
    if ($('#postcode_lookup').data('initialized')) {
        return _this;
    }
    
    getAddress.find(
        'postcode_lookup', //Lookup container ID
        postcode_api_key, // API Key
        // options
        {
            input:{
                id:postCodeId,  /* The id of the textbox' */
                name:postCodeName,  /* The name of the textbox' */
                class:'form-control',  /* The class of the textbox' */
                label:'Enter your Postcode'  /* The label of the textbox' */
            },
            button:{
                id:findAddressBtnId,  /* The id of the botton' */
                class:'btn btn-primary btn-apply',  /* The class of the botton' */
                label:'Find Address',  /* The label of the botton' */
                type:'button',
                disabled_message:'Fetching...',  /* The disabled message of the botton' */
            },
            dropdown:{
                id:postCodeSelectId,  /* The id of the dropdown' */
                class:'form-control find-dropdown',  /* The class of the dropdown' */
                select_message:'Select your Address',  /* The select message of the dropdown' */
                template:''  /* The suggestion template of the dropdown' (see Autocomplete API)*/
            },
            error_message:{
                id:'getaddress_error_message',  /* The id of the error message' */
                class:'text-danger',  /* The class of the error message' */
                not_found:'No addresses could be found for this postcode.',  /* The 'not found' message of the error message' */
            },
            
        }
    );
    // Mark postcode lookup as initialized
    $('#postcode_lookup').data('initialized', true);
    return _this;
}